import React, { useState, useEffect } from 'react';
import FlippexLoader from '../components/ui/FlippexLoader';
import Header from '../components/Header';
import { Card } from '../components/ui/card';
import { useAuth, api } from '../context/AuthContext';
import { Bell, CheckCircle } from 'lucide-react';

const NotificationsPage = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const response = await api.get('/notifications');
      setNotifications(response.data);
    } catch (error) {
      console.error('Error fetching notifications:', error);
    } finally {
      setLoading(false);
    }
  };

  const markAsRead = async (id) => {
    try {
      await api.put(`/notifications/${id}/read`);
      setNotifications(
        notifications.map((n) => (n.id === id ? { ...n, read: true } : n))
      );
    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <FlippexLoader size={64} animate={false} />
      </div>
    );
  }

  return (
    <div className="min-h-screen" data-testid="notifications-page">
      <Header />

      <div className="container mx-auto px-4 md:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-heading font-bold mb-8">Notifications</h1>

        <Card className="glass p-6">
          {notifications.length === 0 ? (
            <div className="text-center py-12">
              <Bell className="h-12 w-12 text-foreground-muted mx-auto mb-4" />
              <p className="text-foreground-muted">No notifications yet</p>
            </div>
          ) : (
            <div className="space-y-3">
              {notifications.map((notification) => (
                <div
                  key={notification.id}
                  className={`p-4 rounded-lg cursor-pointer transition-colors ${
                    notification.read ? 'bg-background-subtle' : 'bg-primary/5 border border-primary/20'
                  }`}
                  onClick={() => !notification.read && markAsRead(notification.id)}
                  data-testid={`notification-${notification.id}`}
                >
                  <div className="flex items-start space-x-3">
                    <CheckCircle className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center justify-between mb-1">
                        <h3 className="font-semibold">{notification.title}</h3>
                        {!notification.read && (
                          <span className="text-xs text-primary font-medium">New</span>
                        )}
                      </div>
                      <p className="text-sm text-foreground-muted">{notification.message}</p>
                      <p className="text-xs text-foreground-muted mt-2">
                        {new Date(notification.created_at).toLocaleString()}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </Card>
      </div>
    </div>
  );
};

export default NotificationsPage;
